import type { RouteRecordRaw } from "vue-router";

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: "/admin/passcode-manager",
    name: "passcode-manager",
    component: () => import("../../views/Admin/PasscodeManager.vue"),
    meta: { requiresAuth: true, requiresStaff: true, pageHeader: "Passcode Manager" },
  },
  {
    path: "/admin/qr-code-manager",
    name: "qr-code-manager",
    component: () => import("../../views/Admin/QRCodeManager.vue"),
    meta: { requiresAuth: true, requiresStaff: true, pageHeader: "Qr Code Manager" },
  },
  {
    path: "/admin/c1",
    name: "C1",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/C1.vue"),
    meta: { requiresAuth: true, requiresStaff: true },
  },
  {
    path: "/admin/fullscreen-stats",
    name: "Stats",
    component: () => import("../../views/FullscreenStats.vue"),
    meta: { requiresAuth: true, requiresStaff: true, noMargin: true },
  },
  {
    path: "/admin/translations",
    name: "translations-edit",
    component: () => import("../../views/Admin/EditTranslations.vue"),
    meta: { requiresAuth: true, requiresStaff: true },
  },
];
